module.exports = "<div class=\"vis-filter-bar\">\n  <div class=\"vis-filter-bar-left\">\n    <slot name=\"left\"></slot>\n  </div>\n  <div class=\"vis-filter-bar-right\">\n    <slot name=\"right\"></slot>\n  </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./~/wc-visualisation/src/components/filter-bar.html
// module id = 309
// module chunks = 0